<router-outlet></router-outlet>

<footer>
    <a class="settings-link"
       (click)="navigateToSettingsPage()"
       data-test="settings-button"><i class="fal fa-cog"></i></a>
</footer>
